import "./helvetica.css2.js";
const s = "https://static.parastorage.com/services/fonts-data/dist/helvetica.kjfcsiz3wknjb7wdq77b.css";
export {
  s as default
};
//# sourceMappingURL=helvetica.css.js.map
